var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoServices(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "29px",
    height: "33px",
    viewBox: "0 0 29 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Picto Services") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PICTOGRAMAS",
    transform: "translate(-63.000000, -392.000000)",
    stroke: "#00A9FD",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Picto-Services",
    transform: "translate(52.000000, 383.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.083739,22.7533593 L30.0128384,26.82426 L27.0161538,23.8275755 L31.0854771,19.7582522 C30.5629601,19.5717235 30.0029796,19.4644596 29.4165774,19.4644596 C26.6758277,19.4644596 24.4540458,21.6866358 24.4540458,24.4273856 C24.4540458,25.0137877 24.5609153,25.5737683 24.747444,26.0962853 L16.5563486,34.2873807 L16.5618695,34.2929017 C16.179742,34.6750292 15.9435248,35.2026728 15.9435248,35.7855258 C15.9435248,36.9516261 16.8887877,37.896889 18.054888,37.896889 C18.637741,37.896889 19.1653846,37.6606719 19.5475122,37.2785443 L19.5530331,37.2840652 L27.7425511,29.0945472 C28.2662512,29.2826534 28.8282035,29.3903116 29.4165774,29.3903116 C32.1573272,29.3903116 34.3795034,27.1681353 34.3795034,24.4273856 C34.3795034,23.8390117 34.2718452,23.2770594 34.083739,22.7533593 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4860662,10 L38.9721324,21.4431456 L38.9721324,36.4337374 C38.9721324,38.9031889 36.9700049,40.9046156 34.5005696,40.9046156 L16.4715628,40.9046156 C14.0021276,40.9046156 12,38.9031889 12,36.4337374 L12,21.4431456 L25.4860662,10 Z",
    id: "Stroke-5"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoServices);
export default __webpack_public_path__ + "static/media/PictoServices.eb5feee4150340e24f5fc5d74c6af82c.svg";
export { ForwardRef as ReactComponent };